'use client';

import { motion } from 'framer-motion';
import useTopStyle from '../../utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from '../../animation/heroVariants';
import spanVariants from '../../animation/spanVariants';
import Image from 'next/image';
import { ThemeContext } from '../../utils/ThemeContext';
import { useContext } from 'react';

const GenericHero = ({ light, dark, title, highlight, text, visual }) => {
	const ref = useTopStyle(72);
	const { theme } = useContext(ThemeContext);
	const image = theme === 'dark' ? dark : light;

	return (
		<motion.section
			className='generic-hero'
			ref={ref}
			initial={'hidden'}
			animate={'visible'}
			transition={{
				duration: 0.7,
				delay: 0.5,
				ease: 'easeInOut'
			}}
			variants={heroVariants}
		>
			<div className='container'>
				<div className='bg-line'></div>
				<div className='content'>
					<h2 className='title'>
						{title}
						<motion.span
							className='highlight'
							initial={'hidden'}
							animate={'visible'}
							transition={{
								duration: 0.8,
								delay: 0.8,
								ease: 'easeInOut'
							}}
							variants={spanVariants}
						>
							{highlight}
						</motion.span>
					</h2>
					<p className='text'>{text}</p>
					<BookBtn />
				</div>
				<div className='design '>
					{visual ? visual : (light && light.length > 0) || (dark && dark.length > 0) ? (
						<Image src={image} alt={`image of ${title}`} fill={true} />
					) : null}
				</div>
			</div>
		</motion.section>
	);
};

export default GenericHero;
